import { createSelector } from 'reselect';
import moment from 'moment-timezone';
import get from 'lodash/get';
import { stateSelector } from '@store/router/selectors';
import { ALL_TRAFFIC } from '@utils/filter';
import { intervalSelector } from '@store/errorDiagnostics/base/selectors';
import { sliceIntervalSelector } from '@store/errorDiagnostics/birdChart/selectors';
import { getColor } from '@utils';
import { intervalSelector as commonIntervalSelector } from '../common/selectors';
import commonBirdChartSelector from '../common/birdChart/selectors';
import { formatter } from './birdChart/selectors';
import { SCOPE } from './types';

const selector = state => state[SCOPE];

export default selector;

export const filterFromRouterSelector = createSelector(
  stateSelector,
  routerStateStore => ({
    rule: get(routerStateStore, 'filter.rule', ALL_TRAFFIC.rule),
    name: get(routerStateStore, 'filter.name', ALL_TRAFFIC.name),
  }),
);

export const filterColorSelector = createSelector(
  filterFromRouterSelector,
  filter => getColor(0, filter.name),
);

export const intervalPayloadSelector = createSelector(
  intervalSelector,
  sliceIntervalSelector,
  (interval, sliceInterval) => {
    let { from, to } = interval;
    if (sliceInterval.from && sliceInterval.to) {
      from = moment(sliceInterval.from).format();
      to = moment(sliceInterval.to).format();
    }
    return { from, to };
  },
);

export const trendsDisplayIntervalWithoutDrilldownSelector = createSelector(
  commonIntervalSelector,
  commonBirdChartSelector,
  (commonIntervalStore, commonBirdChartStore) => {
    const { sliceFrom, sliceTo } = commonBirdChartStore;
    if (sliceFrom && sliceTo) {
      return [formatter(sliceFrom), formatter(sliceTo)];
    }
    const { from, to } = commonIntervalStore;
    return [formatter(from), formatter(to)];
  },
);

export const modeSelector = createSelector(
  selector,
  trends => ({
    mode: get(trends, 'meta.mode'),
  }),
);
